module.exports = __webpack_public_path__ + "static/media/image-44.a1b1c87e.png";